import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { Helmet } from 'react-helmet'
import Header from '../components/Header'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import Footer from '../components/Footer'
import Search from '../components/Search'
import Results from '../components/Results'
import { observer } from 'mobx-react/index'
import { action, observable } from 'mobx'
import { simple_api_request } from '../api/simple_api_request'
import object_value from '../api/object_value'

@observer
class HomePage extends Component {
  @observable lead_height = 0
  @action set_lead_height = (height) => this.lead_height = height

  @observable lead_visible = true
  @action set_lead_visible = (is_visible) => this.lead_visible = is_visible

  @observable slides = []
  @action set_slides = (slides) => this.slides = slides

  @observable slide = null
  @action set_slide = (slide) => this.slide = slide

  componentDidMount() {
    const {set_slides, run_slideshow} = this

    simple_api_request({
      method: 'GET',
      path: '/api/headers'
    })
      .then(result => {
        console.log('HomePage.js - /api/headers - result:', result)

        if (!result.ok ) {
          console.log('!result.ok')
        }

        set_slides(result.data)
        run_slideshow()

        return result.data
      })
      .catch(error => {
        // this.set_error
        console.log('HomePage.js - /api/headers - error:', error)
      })

    // Scrolling
    window.addEventListener('scroll', this.handleScroll.bind(this))
    this.set_lead_height( this.calc_lead_height() )
    this.setState({lead_height: this.calc_lead_height() })
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  calc_lead_height() {
    console.log('calc_lead_height', this.ref_lead.clientHeight)
    return this.ref_lead.clientHeight
  }

  handleScroll(event) {
    const { lead_height } = this
    this.set_lead_visible(lead_height > window.scrollY)
  }

  run_slideshow = () => {
    const {slides, set_slide} = this

    let i = 0

    set_slide(slides[i])

    if (slides.length > 1) {
      setInterval(() => {
        set_slide(null)

        if (i < slides.length - 1) {
          i++
        } else {
          i = 0
        }

        set_slide(slides[i])
      }, 5000)
    }
  }

  render () {
    const {slide} = this

    const image_url = object_value(slide, 'image_url')
    const image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    return (
      <div className='b-layout'>
        <Helmet title='Home' />

        <section className={this.lead_visible ? 'b-lead b-lead_is-visible' :  'b-lead'}
                 ref={(elem) => this.ref_lead = elem}
                 style={image_style}>

          <Header />

          {slide &&
          <div className='b-lead-panel'>
            <div className='b-lead-title'>{slide.title}</div>
            <div className='b-lead-text'>
              {slide.subtitle}
            </div>
            {slide.experience_id &&
            <div className='b-lead-text'>
              <NavLink to={'/experience/' + slide.experience_id}
                       className='b-button b-button_primary b-button_x'>
                {intl.get('home.discover_now')}
              </NavLink>
            </div>}
          </div>}

          {/*
          <button className='b-lead-arrow b-lead-arrow_left'></button>
          <button className='b-lead-arrow b-lead-arrow_right'></button>
          <div className='b-lead-dots'>
            <button className='b-lead-dots-dot current'></button>
            <button className='b-lead-dots-dot'></button>
            <button className='b-lead-dots-dot'></button>
          </div>
          */}

          <div className='b-lead-search'>
            <Search redirect={true} />
          </div>
        </section>

        <Results type='landing'
                 maxCategoryExperiences={5} />

        <Footer type='landing' />
      </div>
    )
  }
}

export default HomePage



// WEBPACK FOOTER //
// ./src/containers/HomePage.js